/**
 * Components: Category.
 *
 * The category component.
 *
 * @since 3.11.0
 */

/**
 * External dependencies
 */
import styled from 'styled-components';

const Category = styled.div`
	display: inline-block;
	position: relative;
	top: -4px;	
	line-height: 16px;
	font-size: 12px;
`;

// Finally export the `Category`.
export default Category;
